import { axiosPublic, baseUrl } from '../config';
import { getAppSource, getUserType } from '../helpers';
import Cookies from 'js-cookie';
import axios from 'axios';

export const verifyQuickPayAccount = async (data) => {
  try {
    var res = await axiosPublic.post('/OT/PaymentLanding', data)
    return res.data
  } catch (e) {    
    return res
  }
}

export const validateQuickPayOTP = async (data) => {
  try {
    const otp = await axiosPublic.post('/OT/ValidateQuickPayOTP', data);
    return otp.data
  } catch (e) {
    return null
  }
}

export const deleteAccessTokenQuickPay = async (data, token) => {
  try {
    const otp = await axios.post(`${baseUrl}/OTPayment/QuickPayLogout`,data, {
      headers: {
       'Authorization': `Bearer ${token}`,
       'Content-Type' : 'application/json'
      }})
    return otp.data
  } catch (e) {
    return null
  }
}

export const getRecurringACHInfoQuickPay = async (userDetails) => {
  const data = {
    "accountNumber": userDetails.accountNumber,
    // "accountNumber": "MYIvFnk9MH5bw1LeE5ccIQ==",
    "privateLabelUrl": Cookies.get("privateLabelUrl"),
    "ipAddress": Cookies.get('publicIp'),
    "browser": Cookies.get("browser"),
    "appSource": getAppSource(),
    "userType": getUserType(),
    "userName": "",
  };

  try {
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJnOEg2ak5GcFBkdVJqVXJLaytVa1ZnPT0iLCJpYXQiOiIwOS8yOS8yMDI1IDA3OjA5OjM0IiwiUHJpdmF0ZUxhYmVsQ29kZSI6IjU3QTZLK2l5L0JXOGY2V25DZCtuU2c9PSIsIlVzZXJOYW1lIjoiZzhINmpORnBQZHVSalVyS2srVWtWZz09IiwiVXNlclR5cGUiOiJBQTNja0hKMzhUWkkzTzB2ekUwZzVnPT0iLCJJbnZlc3RvckNvZGUiOiJOcmo0QVlxWjFmbFJISi85U2pvaVZRPT0iLCJBY2NvdW50TnVtYmVyIjoiZzhINmpORnBQZHVSalVyS2srVWtWZz09IiwiRW1haWxJRCI6IkN3RHp5SUVGYXR6NWJFMHd6dTllcFR4UWYvVytNYm5KVjhEbEpQRll5c3c9IiwiRmlyc3ROYW1lIjoiUVJTVFVWIENERUYiLCJSb2xlSUQiOiJLbUJYMy9pcVp3TXFEYW5UaTBIbUJBPT0iLCJGb3JlaWduSWQiOiIiLCJJc011bHRpTG9hbiI6IkZhbHNlIiwiWmlwQ29kZSI6IiIsIm5iZiI6MTc1OTEyOTc3NCwiZXhwIjoxNzU5MTMzMzc0LCJpc3MiOiJodHRwOi8vd3d3LmJzaWZpbmFuY2lhbC5jb20iLCJhdWQiOiJBcHBVc2VyIn0.4biro9SalgvYFJO6zxXeSJ16ZWYqnj5F2S8FnsfiSLY'
    const response = await axios.post(`${baseUrl}/OTPayment/GetRecurringACHInfo`,data, {
      headers: {
       'Authorization': `Bearer ${userDetails.token}`,
       'Content-Type' : 'application/json'
      }})
    return response.data;
  } catch (e) {
    return null
  }
}

export const getOneTimeACHPaymentDetailsQuickPay = async (userDetails) => {
  const data = {
    "accountNumber": userDetails.accountNumber,
    // "accountNumber": "MYIvFnk9MH5bw1LeE5ccIQ==",
    "propertyState": "",
    "privateLabelUrl": Cookies.get("privateLabelUrl"),
    "ipAddress": Cookies.get('publicIp'),
    "browser": Cookies.get("browser"),
    "appSource": getAppSource(),
    "userType": getUserType(),
    "userName": "",
  };

  try {
     const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJnOEg2ak5GcFBkdVJqVXJLaytVa1ZnPT0iLCJpYXQiOiIwOS8yOS8yMDI1IDA3OjA5OjM0IiwiUHJpdmF0ZUxhYmVsQ29kZSI6IjU3QTZLK2l5L0JXOGY2V25DZCtuU2c9PSIsIlVzZXJOYW1lIjoiZzhINmpORnBQZHVSalVyS2srVWtWZz09IiwiVXNlclR5cGUiOiJBQTNja0hKMzhUWkkzTzB2ekUwZzVnPT0iLCJJbnZlc3RvckNvZGUiOiJOcmo0QVlxWjFmbFJISi85U2pvaVZRPT0iLCJBY2NvdW50TnVtYmVyIjoiZzhINmpORnBQZHVSalVyS2srVWtWZz09IiwiRW1haWxJRCI6IkN3RHp5SUVGYXR6NWJFMHd6dTllcFR4UWYvVytNYm5KVjhEbEpQRll5c3c9IiwiRmlyc3ROYW1lIjoiUVJTVFVWIENERUYiLCJSb2xlSUQiOiJLbUJYMy9pcVp3TXFEYW5UaTBIbUJBPT0iLCJGb3JlaWduSWQiOiIiLCJJc011bHRpTG9hbiI6IkZhbHNlIiwiWmlwQ29kZSI6IiIsIm5iZiI6MTc1OTEyOTc3NCwiZXhwIjoxNzU5MTMzMzc0LCJpc3MiOiJodHRwOi8vd3d3LmJzaWZpbmFuY2lhbC5jb20iLCJhdWQiOiJBcHBVc2VyIn0.4biro9SalgvYFJO6zxXeSJ16ZWYqnj5F2S8FnsfiSLY'
    const response = await axios.post(`${baseUrl}/OTPayment/GetOneTimeACHPaymentDetails`,data, {
      headers: {
       'Authorization': `Bearer ${userDetails.token}`,
       'Content-Type' : 'application/json'
      }})
    return response.data;
  } catch (e) {
    return null
  }
}

export const getBankDetailsQuickPay = async (data, userDetails) => {
  try {
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJNcENCNTUrdWZrc3U0SEIzRytYQ3B3PT0iLCJpYXQiOiIwOS8yNC8yMDI1IDA1OjQyOjI2IiwiUHJpdmF0ZUxhYmVsQ29kZSI6IjU3QTZLK2l5L0JXOGY2V25DZCtuU2c9PSIsIlVzZXJOYW1lIjoiTXBDQjU1K3Vma3N1NEhCM0crWENwdz09IiwiVXNlclR5cGUiOiJBQTNja0hKMzhUWkkzTzB2ekUwZzVnPT0iLCJJbnZlc3RvckNvZGUiOiJOcmo0QVlxWjFmbFJISi85U2pvaVZRPT0iLCJBY2NvdW50TnVtYmVyIjoiTXBDQjU1K3Vma3N1NEhCM0crWENwdz09IiwiRW1haWxJRCI6InRiMFE0Rm5aWGl1UmhIenZVaXdDanJsL3dPRnB5T092dHB6c1l0YnRRM2M9IiwiRmlyc3ROYW1lIjoiTU5PUFFSUyBOT1BRUlMiLCJSb2xlSUQiOiJLbUJYMy9pcVp3TXFEYW5UaTBIbUJBPT0iLCJGb3JlaWduSWQiOiIiLCJJc011bHRpTG9hbiI6IkZhbHNlIiwiWmlwQ29kZSI6IiIsIm5iZiI6MTc1ODY5MjU0NiwiZXhwIjoxNzU4Njk2MTQ2LCJpc3MiOiJodHRwOi8vd3d3LmJzaWZpbmFuY2lhbC5jb20iLCJhdWQiOiJBcHBVc2VyIn0.-5PwYLq9tWSNcNNGxGz71ftiygCNoWMvTxaoxynsV-I'
    const response = await axios.post(`${baseUrl}/OTPayment/GetBankDetails`,data, {
      headers: {
       'Authorization': `Bearer ${userDetails.token}`,
       'Content-Type' : 'application/json'
      }})
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      return error.response.data;
    }
    return error
  }
}

export const getDraftOneTimePaymentQuickPay = async (data, userDetails) => {
  try {
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJnOEg2ak5GcFBkdVJqVXJLaytVa1ZnPT0iLCJpYXQiOiIwOC8xMS8yMDI1IDA0OjIxOjA5IiwiUHJpdmF0ZUxhYmVsQ29kZSI6IjU3QTZLK2l5L0JXOGY2V25DZCtuU2c9PSIsIlVzZXJOYW1lIjoiZzhINmpORnBQZHVSalVyS2srVWtWZz09IiwiVXNlclR5cGUiOiJBQTNja0hKMzhUWkkzTzB2ekUwZzVnPT0iLCJJbnZlc3RvckNvZGUiOiJOcmo0QVlxWjFmbFJISi85U2pvaVZRPT0iLCJBY2NvdW50TnVtYmVyIjoiZzhINmpORnBQZHVSalVyS2srVWtWZz09IiwiRW1haWxJRCI6Iks1bm01RU5Ba2JTVU5pK015Ui9GL25DVG1qekJNNzJBa3ZzcWJvZ282TjQ9IiwiRmlyc3ROYW1lIjoiT1hJYzU1SXlDRVN6ZmtTcXdUU1dSZz09IiwiUm9sZUlEIjoiS21CWDMvaXFad01xRGFuVGkwSG1CQT09IiwiRm9yZWlnbklkIjoiIiwiSXNNdWx0aUxvYW4iOiJGYWxzZSIsIlppcENvZGUiOiIiLCJuYmYiOjE3NTQ4ODYwNjksImV4cCI6MTc1NDg5NTA2OSwiaXNzIjoiaHR0cDovL3d3dy5ic2lmaW5hbmNpYWwuY29tIiwiYXVkIjoiQXBwVXNlciJ9.pM8tL0DsIIT2ofB2Dz6oWv-tFPpXC_UkvkP1E0pbXBA'

    const response = await axios.post(`${baseUrl}/OTPayment/DraftOneTimePayment`,data, {
      headers: {
       'Authorization': `Bearer ${userDetails.token}`,
       'Content-Type' : 'application/json'
      }})
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      return error.response.data;
    }
    return error
  }
}

export const insertActivityLogQuickPay = async (data, userDetails) => {
  try {
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJBejZKSXQ4WFZTSUhEaUxqemRSTG9BPT0iLCJpYXQiOiIwMy8xMC8yMDI1IDExOjI4OjQ2IiwiUHJpdmF0ZUxhYmVsQ29kZSI6IjU3QTZLK2l5L0JXOGY2V25DZCtuU2c9PSIsIlVzZXJOYW1lIjoiQXo2Skl0OFhWU0lIRGlManpkUkxvQT09IiwiVXNlclR5cGUiOiJBQTNja0hKMzhUWkkzTzB2ekUwZzVnPT0iLCJJbnZlc3RvckNvZGUiOiJOcmo0QVlxWjFmbFJISi85U2pvaVZRPT0iLCJBY2NvdW50TnVtYmVyIjoiQXo2Skl0OFhWU0lIRGlManpkUkxvQT09IiwiRW1haWxJRCI6Iks1bm01RU5Ba2JTVU5pK015Ui9GL25DVG1qekJNNzJBa3ZzcWJvZ282TjQ9IiwiRmlyc3ROYW1lIjoiblFycHFZNEVqd2FYcEllWTlYZ05XUT09IiwiUm9sZUlEIjoiS21CWDMvaXFad01xRGFuVGkwSG1CQT09IiwiRm9yZWlnbklkIjoiIiwiSXNNdWx0aUxvYW4iOiJGYWxzZSIsIlppcENvZGUiOiIiLCJuYmYiOjE3NDE2MDYxMjYsImV4cCI6MTc0MTYxNTEyNiwiaXNzIjoiaHR0cDovL3d3dy5ic2lmaW5hbmNpYWwuY29tIiwiYXVkIjoiQXBwVXNlciJ9.SV5BFoKDr30fAvnq_eC4UFoB6Lfaf7MlXCf-aDYnL0g'

    const response = await axios.post(`${baseUrl}/Dashboard/InsertActivityLog`,data, {
      headers: {
       'Authorization': `Bearer ${userDetails.token}`,
       'Content-Type' : 'application/json'
      }})
    return response;
  } catch (e) {
    return null
  }
}

export const getUpdatedProcessFees = async (data, userDetails) => {
  try {
    const response = await axios.post(`${baseUrl}/OTPayment/GetCalculateProcessingFee`,data, {
      headers: {
       'Authorization': `Bearer ${userDetails.token}`,
       'Content-Type' : 'application/json'
      }})
    return response.data;
  } catch (error) {
    if (error.response.status === 401) {
      return error.response.data;
    }
    return error
  }
}
